module.exports = __webpack_public_path__ + "img/zc.d4425b7d.png";